module.exports = __webpack_public_path__ + "img/3.b2bf041f.svg";